import {
  type CalendarDate,
  getLocalTimeZone,
  today,
} from '@internationalized/date';
import { useTranslations } from '@rematter/modules/transportation/i18n/useTranslations';
import { Button, DatePicker, SearchField, Toolbar } from '@rematter/ui-web';
import { useAtom, useSetAtom } from 'jotai';
import {
  LucideChevronLeft,
  LucideChevronRight,
  LucidePlusCircle,
} from 'lucide-react';

import {
  $searchTerm,
  $selectedDate,
  $visibleModal,
} from '../../state/loadBoard.localState';

export const LoadBoardToolbar = () => {
  const t = useTranslations();
  const [searchTerm, setSearchTerm] = useAtom($searchTerm);
  const [selectedDate, setSelectedDate] = useAtom($selectedDate);
  const setVisibleModal = useSetAtom($visibleModal);

  const isToday =
    selectedDate.toString() === today(getLocalTimeZone()).toString();

  return (
    <Toolbar className="@LoadBoardToolbar gap-3 px-4 py-2">
      <SearchField
        aria-label={t.loadBoardView.toolbar.loadSearch.aria}
        className="max-w-60 min-w-40"
        placeholder={t.loadBoardView.toolbar.loadSearch.placeholder}
        value={searchTerm}
        onChange={setSearchTerm}
      />
      <div className="flex shrink-0 items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          icon={<LucideChevronLeft />}
          onPress={() => setSelectedDate((d) => d.subtract({ days: 1 }))}
        />
        <DatePicker
          aria-label={t.loadBoardView.toolbar.selectDate}
          value={selectedDate}
          onChange={(date: CalendarDate | null) => {
            if (date) setSelectedDate(date);
          }}
          className="w-[140px] !flex-row items-center !gap-0 [&>label]:!hidden [&>span]:!hidden"
        />
        <Button
          variant="ghost"
          size="icon"
          icon={<LucideChevronRight />}
          onPress={() => setSelectedDate((d) => d.add({ days: 1 }))}
        />
        <Button
          variant={isToday ? 'subtle' : 'outline'}
          color={isToday ? 'primary' : undefined}
          onPress={() => setSelectedDate(today(getLocalTimeZone()))}
        >
          {t.loadBoardView.toolbar.today}
        </Button>
      </div>
      <div className="ml-auto flex shrink-0 gap-2">
        <Button
          variant="outline"
          icon={<LucidePlusCircle className="size-5" />}
          onPress={() => setVisibleModal('create-route')}
        >
          {t.loadBoardView.toolbar.addRoute}
        </Button>
        <Button
          color="primary"
          icon={<LucidePlusCircle className="size-5" />}
          onPress={() => setVisibleModal('create-service')}
        >
          {t.loadBoardView.toolbar.addService}
        </Button>
      </div>
    </Toolbar>
  );
};
